// removed by extract-text-webpack-plugin
module.exports = {"Parent":"src-components----tabs-module---Parent----dlnS","Child":"src-components----tabs-module---Child---JNKSW","selected":"src-components----tabs-module---selected---3WulQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/tabs.module.css
// module id = 41
// module chunks = 29872431572716 35783957827783 255975594985170